import type { SearchResult } from '../lib/types';
import { ResultCard } from './ResultCard';

interface ResultListProps {
  results: SearchResult[];
  activeSlug: string | null;
  hoverSlug: string | null;
  onSelect: (slug: string) => void;
  onHover: (slug: string | null) => void;
}

export function ResultList({
  results,
  activeSlug,
  hoverSlug,
  onSelect,
  onHover,
}: ResultListProps) {
  if (results.length === 0) return null;
  return (
    <section className="result-list">
      {results.map((r) => (
        <ResultCard
          key={`${r.slug}-${r.traversed_from ?? 'seed'}`}
          result={r}
          active={r.slug === activeSlug}
          hovered={r.slug === hoverSlug}
          onSelect={() => onSelect(r.slug)}
          onHover={(h) => onHover(h ? r.slug : null)}
        />
      ))}
    </section>
  );
}
